import axios from 'axios'
import notifService from '../../services/notifService'

export const getArea = async ({ commit }, pagination) => {
  let res = await axios
    .get('/cms/areas', {
      params: pagination
    })
    .then(response => {
      commit('getArea', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const getSubArea = async (_context, val) => {
  let res = await axios
    .get('/cms/areas/sub', {
      params: val
    })
    .then(response => {
      return response.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const getAreaList = async ({ commit }) => {
  let res = await axios
    .get('/cms/areas', {
      params: {
        per_page: 50
      }
    })
    .then(response => {
      commit('getAreaList', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const getSubList = async (_context, val) => {
  let res = await axios
    .get('/cms/areas/sub', {
      params: {
        parent: val,
        per_page: 50
      }
    })
    .then(response => {
      // commit('getAsmList', response.data.data)
      return response.data.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const getAllList = async context => {
  let res = await axios
    .get('/cms/areas/list')
    .then(response => {
      context.commit('getAllList', response.data.data)
      return response.data.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const addArea = async (_context, val) => {
  let res = await axios
    .post('/cms/areas', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return error
    })

  return res
}

export const editArea = async (_context, form) => {
  return await axios
    .put('/cms/areas/' + form.id, {
      name: form.name,
      area_level_id: form.area_level_id,
      initials: form.initials,
      parent_id: form.parent_id,
      hybrid: form.hybrid
    })
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const deleteArea = async (_context, val) => {
  return await axios
    .delete('/cms/areas/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const areaForm = async ({ commit }, val) => {
  commit('areaForm', val)
}

export const areaFormReset = async ({ commit }) => {
  commit('areaFormReset')
}

export const getAreaLevel = async ({ commit }) => {
  let res = await axios
    .get('/cms/areas/level')
    .then(response => {
      commit('getAreaLevel', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}
